import Vue from 'vue'
import Vuex from 'vuex'
import module from './modules/module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    module
  }
  // getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js